import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router";
import { Switch } from "@progress/kendo-react-inputs";
import { Button } from "@progress/kendo-react-buttons";
import { arrowRotateCwIcon as refreshIcon } from "@progress/kendo-svg-icons";
import styles from "components/Dashboard/index.module.scss";
import { getMyTasks } from "api";
import { formatDateForAPI } from "components/common/formatter";
import { TaskItem } from "components/Dashboard";
import TaskItemSkelton from "components/common/Loaders/TaskItemSkelton";

const TasksGrid = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [tasks, setTasks] = useState([]);
    const [showAll, setShowAll] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const isStandaloneDashboard = location.pathname.includes("/sa/dashboard");

    const onMatterRefClick = (task) => {
        if (!task?.matterId) return;
        if (isStandaloneDashboard) {
            window.open(`/sa/casefile/${task.matterId}`, "_blank");
        } else {
            navigate(`/matters/${task.matterId}`);
        }
    };

    const fetchTasks = async (all = showAll) => {
        try {
            setIsLoading(true);
            const date = all ? null : formatDateForAPI(new Date());
            const response = await getMyTasks(date);
            const data = response?.data?.data || response?.data || [];
            setTasks(Array.isArray(data) ? data : []);
        } catch (error) {
        } finally {
            setIsLoading(false);
        }
    };

    const handleShowAllToggle = (checked) => {
        setShowAll(checked);
        fetchTasks(checked);
    };

    useEffect(() => {
        fetchTasks();
    }, []);

    return (
        <div className="h-100 w-100 d-flex flex-column overflow-hidden">
            <div className="d-flex align-items-center justify-content-between flex-shrink-0 p-3 ps-4 pb-2">
                <span className={`${styles["combo-label-font"]} fw-semibold`}>Tasks</span>
                <div className="d-flex align-items-center" style={{ gap: "0.4rem" }}>
                    <Button
                        onClick={() => fetchTasks()}
                        className="common-btn"
                        svgIcon={refreshIcon}
                        title="Refresh"
                        type="button"
                        style={{ minWidth: "23px", height: "23px" }}
                    />
                    <span style={{ height: "15px", width: "1px", background: "#E6E6E6" }}></span>

                    <label className="d-flex align-items-center gap-2 mb-0 cursor-pointer fs-sm">
                        <Switch
                            checked={showAll}
                            onChange={(e) => handleShowAllToggle(e.value)}
                            size="medium"
                        />
                        Show All
                    </label>
                </div>
            </div>

            <div className="overflow-auto flex-grow-1 m-2 mt-0 px-1">
                {isLoading ? (
                    [1, 2, 3, 4, 5].map((i) => (
                        <TaskItemSkelton key={i} />
                    ))
                ) : tasks.length === 0 ? (
                    <div className="text-center text-muted fs-sm pt-4">
                        {showAll ? "No tasks found" : "No tasks due today"}
                    </div>
                ) : (
                    tasks.map((task, index) => (
                        <div key={task.taskId ?? index} className="mt-2">
                            {index > 0 && (
                                <div className="my-2" style={{ height: "1px", background: "#F3F3F3" }} />
                            )}
                            <TaskItem task={task} onMatterRefClick={onMatterRefClick} />
                        </div>
                    ))
                )}
            </div>
        </div>
    );
};

export default TasksGrid;
